import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExercicesProvider } from '../../providers/exercices-provider';
import { SessionItemRow, SessionItemsProvider } from '../../../sessions/providers/sessionItems-provider';
import { BreadcrumbProvider, Crumb } from '../../../breadcrumb/providers/breadcrumb-provider';
import { UserDefaultHomepageService } from '../../../common/providers/user-default-homepage.service';
import { Subscription } from 'rxjs';
import { Exercice } from "../../../common/models/exercice";
import { Organization } from "../../../common/models/organization";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { LibrariesSideMenuComponent } from "../../../libraries/components/side-menu/side-menu";
import { SideMenuComponent } from "../../../common/components/side-menu/side-menu";
import { Error404Component } from "../../../common/components/error-404/error-404";
import { Error401Component } from "../../../common/components/error-401/error-401";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import {
  SessionExerciceDurationComponent
} from "../../../sessions/components/session-exercice-duration/session-exercice-duration";
import {
  SessionExerciceRepeatComponent
} from "../../../sessions/components/session-exercice-repeat/session-exercice-repeat";
import { NgIf } from "@angular/common";

@Component({
  selector: 'exercise-show-component',
  standalone: true,
  providers: [UserDefaultHomepageService],
  styleUrls: ['./exercise-show.component.scss'],
  imports: [
    HeaderComponent,
    PageContentComponent,
    LibrariesSideMenuComponent,
    SideMenuComponent,
    Error404Component,
    Error401Component,
    ModuleContentComponent,
    TranslateModule,
    FlexLayoutModule,
    SessionExerciceDurationComponent,
    SessionExerciceRepeatComponent,
    NgIf
  ],
  templateUrl: './exercise-show.component.html'
})
export class ExerciseShowComponent implements OnInit, OnDestroy {

    public readonly EXERCISE_TYPE_REPEAT = Exercice.TYPE_REPEAT;
    public readonly EXERCISE_TYPE_DURATION = Exercice.TYPE_DURATION;

    public pageTitle = '';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public organization: Organization = {} as Organization;
    public exercise: Exercice = {} as Exercice;
    public totalTime = 0;
    public data: SessionItemRow = {} as SessionItemRow;

    public sessionId: number | null = null;
    private subscriptions: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private exerciseProvider: ExercicesProvider,
        private sessionItemsProvider: SessionItemsProvider,
        private breadcrumbProvider: BreadcrumbProvider,
        private userDefaultHomepageService: UserDefaultHomepageService,
        private _sessionItemsProvider: SessionItemsProvider,
    ) {
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => {//{ organization: Organization; exercise: Exercice }
                this.organization = data.organization;
                this.exercise = data.exercise;

                if (null === this.exercise) {
                    this.isLoading = false;

                    return;
                }

                this.subscriptions.push(
                    this.route.queryParams.subscribe((params) => {
                        this.sessionId = +params['session'];

                        if (this.sessionId && !Number.isNaN(this.sessionId)) {
                            this._sessionItemsProvider.listSessionItemRows(this.organization, this.sessionId).subscribe({
                                next: (rows) => {
                                    for (const innerElement of rows[0].innerElements) {
                                        if (innerElement.data && innerElement.data.exercice && innerElement.data.exercice.exercice && this.exercise && innerElement.data.exercice.exercice.id === this.exercise.id) {
                                            this.data = innerElement;
                                            this.createBreadcrumb();
                                            this.isLoading = false;

                                            return;
                                        }
                                    }
                                }
                            });
                        }

                        this.exerciseProvider.getExerciceRow(this.organization, this.exercise.id!).subscribe({
                            next: (row) => {
                                this.data = this.sessionItemsProvider.getEmptyItemExercice(row);
                                this.totalTime = this.exerciseProvider.getTotalTime(row);

                                this.createBreadcrumb();

                                this.isLoading = false;
                            }
                        });
                    })
                );
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    private createBreadcrumb() {
        this.subscriptions.push(
            this.userDefaultHomepageService.getDashboardUrl().subscribe((dashboardUrl) => {
                const crumbs: Crumb[] = [{
                    shortTitle: 'Dashboard',
                    title: 'Dashboard',
                    url: dashboardUrl,
                }, {
                    shortTitle: this.data.data.exercice.exercice.name,
                    title: this.data.data.exercice.exercice.name,
                }];

                this.breadcrumbProvider.setDefaultCrumbs(crumbs);
            })
        );
    }
}
